import { render, staticRenderFns } from "./MycollectionMoveFile.vue?vue&type=template&id=add28cce&scoped=true"
import script from "./MycollectionMoveFile.vue?vue&type=script&lang=js"
export * from "./MycollectionMoveFile.vue?vue&type=script&lang=js"
import style0 from "./MycollectionMoveFile.vue?vue&type=style&index=0&id=add28cce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add28cce",
  null
  
)

export default component.exports